module.exports = __webpack_public_path__ + "static/media/nav-part-white.31e56563.svg";